export const customStyles = {
    menu: (base) => ({ ...base, zIndex: 9999, backgroundColor: "#fff" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    valueContainer: (baseStyles) => ({ ...baseStyles, maxHeight: "4.5vw", overflowY: "auto" }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        flexWrap: "nowrap",
        width: '100%',
        minWidth: '150px',
        maxWidth: '100%',
        backgroundColor: state.isDisabled ? "#e9ecef" : "#fff"
    })
};


export const largerSelectStyles = {
    ...customStyles,
    control: (baseStyles, state) => ({
        ...baseStyles,
        flexWrap: "nowrap",
        flex: 1,
        minWidth: '0',
        width: '100%',
        maxWidth: 'none',
        backgroundColor: state.isDisabled ? "#e9ecef" : "#fff"
    })
};